/* global common */
import {
  debounce,
  stripTags,
  appendCurrentDomainPrefix,
  sendGoogleEvent,
  ucfirst,
  parameters,
  isElementOnScreen,
  libInit,
  sendRequest,
} from '@html/_common/utils';
import AMCommonMonthSelector from '@atomic/molecules/_common/month-selector/month-selector';

export default function MainSearch() {
  const maxResults = 5;
  let isSearchInitiated = false;
  let checkDestination = false;
  let firstResultUrl = false;
  let firstResultText = false;
  let initiateFromCookies = false;
  let typesLoaded = false;
  let searchTerm = '';
  let $form;
  let $searchInput;
  let $monthBlock;
  let $typeBlock;
  let $ctaButton;
  let $initiateFromCookies;
  let $defaultSuggestions;
  let defaultSuggestionsCount;
  let mobileParameters;
  let selectedIndex;
  let groupTypes;
  let defaultDestinationSelect;
  let blockName;
  let onSwitchMobileToNext;

  if (typeof common !== 'undefined') {
    this.common = common;
  } else if (typeof sendGoogleEvent !== 'undefined') {
    this.common = {
      sendGoogleEvent,
      parameters,
      sendRequest,
      func: {
        debounce,
        stripTags,
        appendCurrentDomainPrefix,
        isElementOnScreen,
        ucfirst,
      },
      lib: {
        init: libInit,
      },
    };
  }

  this.init = this.initiate;

  this.initiateSearch = (searchIndexes, isShop) => {
    $searchInput = $form.find('input.a');
    $searchInput.on('keydown', this.common.func.debounce(this.onKeyDown, 100));

    $searchInput.tinyAutocomplete({
      url: 'https://3VPAXN8SSR-dsn.algolia.net/1/indexes/*/queries',
      method: 'post',
      getRequestData: (query) => {
        const queryParams = {
          query,
          attributesToRetrieve: 'name,type_name,operator_name,url,url_alternative',
          attributesToHighlight: '',
          hitsPerPage: maxResults,
        };

        let requestArray = [];

        const hasPassedIndexesToSearch = !!searchIndexes;
        const isPassedSearchIndexSetToAll = hasPassedIndexesToSearch && searchIndexes[0] === 'all';
        const shouldSearchAllIndexes = !hasPassedIndexesToSearch || isPassedSearchIndexSetToAll;
        if (shouldSearchAllIndexes) {
          requestArray = [
            { indexName: window.trConfig.algolia.indexes.serp, params: $.param(queryParams) },
            { indexName: window.trConfig.algolia.indexes.operators, params: $.param(queryParams) },
            {
              indexName: window.trConfig.algolia.indexes.tours,
              params: $.param({
                ...queryParams,
                filters: isShop ? 'active_shop = 1' : 'active_marketplace = 1',
              }),
            },
          ];
        } else {
          requestArray = this.generateCustomRequestArray(searchIndexes, queryParams, isShop);
        }

        return JSON.stringify({
          requests: requestArray,
          strategy: 'stopIfEnoughMatches',
        });
      },
      ajaxSettings: {
        type: 'post',
        contentType: 'application/json',
        dataType: 'json',
        beforeSend(xhr) {
          xhr.setRequestHeader('X-Algolia-API-Key', window.trConfig.algolia.api_key);
          xhr.setRequestHeader('X-Algolia-Application-Id', window.trConfig.algolia.app_id);
        },
      },
      showNoResults: true,
      itemTemplate: '<li class="autocomplete-item" data-url="{{url}}" data-url-alternative="{{urlAlternative}}" data-type="{{eventType}}"><div>{{title}}</div><span>{{type}}</span></li>',
      noResultsTemplate: '<li class="autocomplete-item" data-url="0" data-type="" data-title="{{title}}"><div>Search for \'{{title}}\'</div></li>',
      onSelect: (element) => {
        const $element = $(element);
        let url = this.common.func.stripTags($element.data('url'));
        let urlAlternative = this.common.func.stripTags($element.data('url-alternative'));
        const type = this.common.func.stripTags($element.data('type'));
        searchTerm = $form.find('input.a').val();

        if (url === '0' && $element.hasClass('autocomplete-item')) {
          // Handle no-results template: use just the title, clear URL data
          const titleOnly = $element.data('title');
          $form.find('input.a').val(titleOnly).data('url', '');
          checkDestination = false;
        } else if (url && $element.hasClass('autocomplete-item')) {
          url = this.common.func.appendCurrentDomainPrefix(url);
          if (urlAlternative) {
            urlAlternative = this.common.func.appendCurrentDomainPrefix(urlAlternative);
          }

          let text = $element.html().replace(/<span>(.*)<\/span>/g, '').replace('amp;', '');
          text = this.common.func.stripTags(text);
          $form.find('input.a').val(text).data('url', urlAlternative || url);
          checkDestination = $form.find('input.a').val();
          this.common.sendGoogleEvent('Main Search', `Select ${this.common.func.ucfirst(type.toLowerCase())}`, checkDestination);

          if (mobileParameters) {
            if (!mobileParameters.headerClass) return;

            const $subHeader = $(`.${mobileParameters.headerClass}--when .${mobileParameters.subHeaderClass}`);

            if (!$subHeader.length) return;

            const $subHeaderWho = $(`.${mobileParameters.headerClass}--who .${mobileParameters.subHeaderClass}`);
            const textSubHeader = $subHeader.data('placeholder')?.replace('{{destination}}', $form.find('input.a').val());

            $subHeader.text(textSubHeader);
            $subHeaderWho.text(textSubHeader);

            this.switchMobileToNext('when');
          }

          if ($monthBlock && !$monthBlock.find('.months .active').length) {
            $monthBlock.click();
          }
        } else {
          $form.find('input.a').val('').data('url', '');
        }
      },
    }).on('beforerequest', () => {
      if (!$form.find('.autocomplete .l').length) {
        $form.find('.autocomplete').append('<img class="l" src="/im/r/pw/tr-loader-small.gif">');
      }
    }).on('receivedata', (ev, tinyAutocomplete, json) => {
      firstResultUrl = false;
      firstResultText = false;

      const data = [];
      for (let i = 0; i < json.results.length; i += 1) {
        const { hits } = json.results[i];
        for (let j = 0; j < hits.length; j += 1) {
          let type = 'MIX';
          let eventType = 'MIX';

          if (hits[j].type_name) {
            eventType = hits[j].type_name;
            type = eventType;
          } else if (json.results[i].index === window.trConfig.algolia.indexes.operators) {
            eventType = 'Operator';
            type = eventType;
          } else if (json.results[i].index === window.trConfig.algolia.indexes.tours) {
            type = hits[j].operator_name;
            eventType = 'Tour';
          }

          data.push({
            title: hits[j].name,
            url: hits[j].url,
            urlAlternative: hits[j].url_alternative || '',
            type,
            eventType,
          });

          if (!firstResultUrl) {
            firstResultUrl = hits[j].url_alternative || hits[j].url;
            firstResultText = hits[j].name;
          }
        }
      }

      /* eslint-disable-next-line */
      tinyAutocomplete.json = data;

      $form.find('.autocomplete img.l').remove();
      this.hideDefaultSuggestions();
    }).on('keydown keypress change focus input', (event) => {
      if ($(event.currentTarget).val().length > 0) {
        return;
      }

      const $resultsList = $form.find('.autocomplete-list:not(.pre)');
      const isResultsListVisible = $resultsList.length && $resultsList.css('display') !== 'none';
      if (isResultsListVisible) {
        $resultsList.remove();
      }

      $form.find('.autocomplete .pre').show();
      if (this.monthSelector) {
        this.monthSelector.hideMonths();
      }

      if (this.isMobileFlow()) {
        $(window).scrollTop(0);
      }
    })
      .on('keydown', (event) => {
        searchTerm = '';

        const code = (event.keyCode ? event.keyCode : event.which);
        if (code === 13 || code === 9) {
          if (this.monthSelector) {
            this.monthSelector.hideMonths();
          }

          const $list = $form.find('.autocomplete .autocomplete-list').last();
          const index = $list.find('.autocomplete-item.active').index();

          if (code === 13) {
            if ($list.css('display') !== 'none') {
              if (index === -1) {
                event.stopPropagation();

                $list.find('.autocomplete-item:first-child').click();

                $ctaButton.click();
              }
            } else {
              $ctaButton.click();
            }
          }

          if (code === 9) {
            event.preventDefault();

            $monthBlock.click();
          }
        }
      });
  };

  this.switchMobileToNext = (block) => {
    if (!mobileParameters) {
      return;
    }

    onSwitchMobileToNext?.(block);

    const $back = $(`.${mobileParameters.back}`);
    const $footer = $(`.${mobileParameters.footer}`);
    const $cta = $(`.${mobileParameters.cta}`);

    $(`.${mobileParameters.flowClass} .${mobileParameters.headerClass}`).addClass('hid');
    $(`.${mobileParameters.flowClass} .${mobileParameters.headerClass}--${block}`).removeClass('hid');

    $(`.${mobileParameters.flowClass} .${mobileParameters.searchItem}`).addClass('hid').removeClass('show');
    $(`.${mobileParameters.flowClass} .${mobileParameters.mainClassName}${block}`).removeClass('hid').addClass('show');

    $back.addClass('hid');
    $footer.addClass('hid');

    if (block === 'when') {
      $back.removeClass('hid');
      $footer.removeClass('hid');

      $cta.removeClass(mobileParameters.ctaClass).text($cta.data('placeholder-init'));
      this.initMonth();

      if (this.isMobileFlow()) {
        $(mobileParameters.switchContainer).hide();
        setTimeout(() => {
          this.showMonths();
        }, 30);
      }
    }

    if (block === 'who') {
      $back.removeClass('hid');
      $footer.removeClass('hid');

      $cta.addClass(mobileParameters.ctaClass).text($cta.data('placeholder'));
      this.initiateTypes();
    }
  };

  this.generateCustomRequestArray = (searchIndexes, queryParams, isShop) => {
    const requestArray = [];

    for (let i = 0; i < searchIndexes.length; i += 1) {
      const indexObject = {};
      const indexName = searchIndexes[i];
      indexObject.indexName = window.trConfig.algolia.indexes[indexName];
      const params = { ...queryParams };
      if (indexName === 'tours') {
        params.filters = isShop ? 'active_shop = 1' : 'active_marketplace = 1';
      }

      indexObject.params = $.param(params);

      requestArray.push(indexObject);
    }

    return requestArray;
  };

  this.initiate = (params) => {
    $form = params.$searchInput;
    $searchInput = $form.find('input.a');
    ({ $monthBlock } = params);
    ({ onSwitchMobileToNext } = params);
    ({ $typeBlock } = params);
    ({ $ctaButton } = params);
    ({ $initiateFromCookies } = params);
    ({ defaultDestinationSelect } = params);
    ({ mobileParameters } = params);
    ({ blockName } = params);

    $form.find('input').val('');

    initiateFromCookies = $initiateFromCookies;

    if (this.common.parameters.deviceType === 'desktop' && this.common.func.isElementOnScreen($searchInput) && !params.disableFocus) {
      $searchInput.focus();
    }

    if (this.isMobileFlow()) {
      $(mobileParameters.switchContainer).find('input#standard').prop('checked', true);
    }

    $searchInput.one('focus click keydown input', () => {
      if (!isSearchInitiated) {
        isSearchInitiated = true;

        this.common.lib.init('autocomplete', () => {
          this.initiateSearch(params.searchIndexes, params.isShop);

          const $whereLabel = $searchInput.parent().next('label');
          const $autocompleteWrapper = $form.find('.autocomplete');
          if ($autocompleteWrapper.length) {
            if ($whereLabel.length) {
              $autocompleteWrapper.append($whereLabel.detach());
            }

            if (this.isMobileFlow() && mobileParameters.cleanButton) {
              const $cleanButton = $form.find(`.${mobileParameters.cleanButton}`);
              $autocompleteWrapper.append($cleanButton.detach());

              this.initCleanButton($form.find(`.${mobileParameters.cleanButton}`));
            }
          }

          $(document).mouseup((event) => {
            if ($form.find('.autocomplete-list').css('display') !== 'none' && !$form.find('.autocomplete').find(event.target).length) {
              this.hideDefaultSuggestions();
            }
          });

          $searchInput.focus((event) => {
            const $target = $(event.currentTarget);
            if (!$target.val()) {
              $target.data('url', '');
              $form.find('.autocomplete .pre').show();
            }

            if (this.isMobileFlow()) {
              if (!mobileParameters.flowClass) {
                return;
              }
              $(`.${mobileParameters.container}`).addClass(mobileParameters.flowClass);
              $('body').addClass('lock');
              $('html, body').addClass('search-focused');
              $(mobileParameters.switchContainer).css('display', 'flex');
              $(window).scrollTop(0);
            }

            if (this.monthSelector) {
              this.monthSelector.hideMonths();
            }
          });
          $searchInput.focus();

          this.common.sendRequest('/api/homepage/load', {
            action: 'preload_search',
          }, (data) => {
            if (data.status === 'OK') {
              $form.find('.autocomplete').append(data.component);

              if (this.isMobileFlow()) {
                $(window).scrollTop(0);
              }

              if (this.monthSelector) {
                this.monthSelector.hideMonths();
              }

              $defaultSuggestions = $form.find('.autocomplete-list.pre');
              defaultSuggestionsCount = $defaultSuggestions.find('.autocomplete-item').length;
              selectedIndex = -1;

              this.common.sendGoogleEvent(
                'Main Search',
                'Search',
                'Click - Input',
                {
                  blockName,
                  ampEventName: 'search_destination_clicked',
                  search_method: 'CLP',
                },
              );
            }
          });
        });
      }
    });

    if ($monthBlock && $form.data('month')) {
      setTimeout(() => {
        $monthBlock.click();
      }, 100);
    }

    const $monthInput = $monthBlock?.find('input');
    if ($monthInput) {
      $monthInput.click(this.initMonth);
    }

    if ($typeBlock && $typeBlock.length) {
      const $typeInput = $typeBlock.find('input');
      $typeInput.click(() => {
        this.initiateTypes();
      });
    }
    $ctaButton?.click(this.searchAction);
  };

  this.initCleanButton = ($button) => {
    $button.click(() => {
      if (!$searchInput || !$searchInput.length) {
        return;
      }

      $searchInput.val('');
      $searchInput.focus();
    });
  };

  this.showMonths = () => {
    if (!this.monthSelector) {
      return;
    }

    this.monthSelector.showMonths();
  };

  this.deSelectMonths = () => {
    if (!this.monthSelector) {
      return;
    }

    this.monthSelector.deselectSelectedMonths();

    if (!mobileParameters) {
      return;
    }

    const $subHeaderWhen = $(`.${mobileParameters.headerClass}--when .${mobileParameters.subHeaderClass}`);
    const $subHeaderWho = $(`.${mobileParameters.headerClass}--who .${mobileParameters.subHeaderClass}`);
    const textSubHeader = $subHeaderWhen.data('placeholder').replace('{{destination}}', $form.find('input.a').val());

    $subHeaderWho.text(textSubHeader);
  };

  this.showWhere = () => {
    if (!$searchInput || !$searchInput.length) {
      return;
    }

    $searchInput.focus();
    $(window).scrollTop(0);
  };

  this.searchAction = () => {
    if (defaultDestinationSelect && !checkDestination) {
      checkDestination = defaultDestinationSelect;
    }

    if (!searchTerm) {
      searchTerm = $searchInput.val();
    }

    if (this.monthSelector) {
      this.monthSelector.hideMonths();
    }

    if ($typeBlock && $typeBlock.length) {
      this.toggleTypes('close');
    }

    if ($searchInput.val().trim() === '') {
      $searchInput.focus().addClass('shake').data('url', '');
      this.common.sendGoogleEvent('Main Search', 'Search', 'Error');

      setTimeout(() => {
        $searchInput.removeClass('shake');
      }, 1000);

      return;
    }

    let destination = $searchInput.data('url');
    if ((!destination || checkDestination !== $searchInput.val()) && firstResultUrl) {
      destination = firstResultUrl;
      checkDestination = firstResultText;
      $searchInput.val(firstResultText);
    }
    const months = this.monthSelector ? this.monthSelector.getValue() : '';

    if (!destination || (!initiateFromCookies && checkDestination !== $searchInput.val())) {
      checkDestination = false;

      this.redirectToResultsPage();
    } else {
      const monthsName = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
      let searchTime = $('input.js-ao-clp-clean-search__when-input').val();
      const searchTourType = $('label.js-ao-clp-clean-search__who-label').text();

      const numberOfAdults = $('.js-ao-pax-travelers')?.attr('data-pax-adults') || 0;
      const numberOfChildren = $('.js-ao-pax-travelers')?.attr('data-pax-children') || 0;

      if ($('.js-ao-pax-month').attr('data-pax-month') && $('.js-ao-pax-month').attr('data-pax-year')) {
        const month = $('.js-ao-pax-month').attr('data-pax-month');
        const year = $('.js-ao-pax-month').attr('data-pax-year');
        searchTime = `${monthsName[month - 1]}-${year}`;
      }

      this.common.sendGoogleEvent(
        'Main Search',
        'Search',
        `Success - ${searchTerm}`,
        {
          blockName,
          searchTerm: $searchInput.val(),
          searchTime,
          searchTourType,
          ampEventName: 'on_site_search_completed',
          adultPaxCount: numberOfAdults,
          childrenPaxCount: numberOfChildren,
        },
      );

      const appliedFilters = this.buildSearchString(months);
      let paxFilters = '';
      destination = this.common.func.appendCurrentDomainPrefix(destination);

      if (destination.includes('/srp/') && $('.js-ao-pax-month').attr('data-pax-month')) {
        const month = $('.js-ao-pax-month').attr('data-pax-month');
        const year = $('.js-ao-pax-month').attr('data-pax-year');
        let travelers = '';

        if ($('.js-ao-pax-travelers').attr('data-pax-adults')) {
          travelers = `adults=${$('.js-ao-pax-travelers').attr('data-pax-adults')}`;
        }
        if ($('.js-ao-pax-travelers').attr('data-pax-children')) {
          travelers = `${travelers},children=${$('.js-ao-pax-travelers').attr('data-pax-children')}`;
        }
        if (appliedFilters && appliedFilters.includes('#month')) {
          paxFilters = `${travelers}`;
        } else {
          paxFilters = `month=${monthsName[month - 1]}-${year},${travelers}`;
        }
        paxFilters = `${appliedFilters ? ',' : '#'}${paxFilters}`;
      }

      const searchedValue = $searchInput?.val() ? $searchInput.val() : searchTerm;

      if (destination && searchedValue) {
        document.cookie = `pax_search_value=${searchedValue}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
        document.cookie = `pax_search_url=${destination}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
      }
      window.location.href = `${destination}${appliedFilters}${paxFilters}`;
      if (destination === window.location.pathname) {
        window.location.reload();
      }
    }
  };

  this.buildSearchString = (months) => {
    this.groupTypeCheckbox();

    let groupTypeSearchTerm = '';
    if (groupTypes) {
      Object.keys(groupTypes).forEach((group) => {
        if (!groupTypes[group].length) {
          return;
        }

        const selectedValues = groupTypes[group].join(':');
        groupTypeSearchTerm = groupTypeSearchTerm ? groupTypeSearchTerm.concat(',') : '';
        groupTypeSearchTerm = groupTypeSearchTerm.concat(`${group}=${selectedValues}`);
      });
    }

    groupTypeSearchTerm = groupTypeSearchTerm ? `${months ? ',' : '#'}${groupTypeSearchTerm}` : '';

    return `${months ? `#month=${months}` : ''}${groupTypeSearchTerm || ''}`;
  };

  this.initiateTypes = () => {
    if (typesLoaded) {
      this.toggleTypes();
      return;
    }

    this.common.sendRequest('/api/homepage/load', {
      action: 'preload_types',
    }, ({ status, component }) => {
      if (status === 'OK') {
        $typeBlock.append(component);
        typesLoaded = true;
        this.initTypes();
      }
    });
  };

  this.initMonth = () => {
    if (!this.monthSelector) {
      this.common.sendRequest('/api/homepage/load', {
        action: 'preload_search_months',
      }, ({ status, component }) => {
        if (status === 'OK') {
          $monthBlock.append(component);
          this.monthSelector = new AMCommonMonthSelector(this.common);
          this.monthSelector.initiate({
            $container: $monthBlock,
            $input: $monthBlock.find('input'),
            gaCategory: 'Main Search',
            onMonthSelect: () => {
              if (!mobileParameters) {
                return;
              }

              const $subHeader = $(`.${mobileParameters.headerClass}--who .${mobileParameters.subHeaderClass}`);

              if (this.monthSelector.getText()) {
                $subHeader.text($subHeader.data('placeholder').replace('{{destination}}', $form.find('input.a').val()).replace('{{month}}', this.monthSelector.getText()));
              }

              this.switchMobileToNext('who');
            },
          });

          if (this.monthSelector.getValue() && this.monthSelector.isVisible()) {
            this.hideDefaultSuggestions();
          }

          this.monthSelector.showMonths();
        }
      });
    }
  };

  this.isMobileFlow = () => mobileParameters && $(window).width() <= mobileParameters.width;

  this.initTypes = () => {
    const switchAdventureTypeClass = '.ao-clp-clean-search__switch';
    const TOUR_TYPE_ID_PERSONALIZED = '402';
    const selectedAdventureType = $(switchAdventureTypeClass).find('input:checked').val();

    $('body').on('click', (event) => {
      const isTypeClicked = $(event.target).closest('.am-type-selector__wrapper').length || $(event.target).parent().find('.am-type-selector__wrapper').length;
      if (isTypeClicked) {
        return;
      }

      this.toggleTypes('close');
    });

    $typeBlock.find('input[type="checkbox"]').change((event) => {
      const $checkedGroupType = $typeBlock.find('input:checked');
      const checkedNames = [];
      const checkedNamesLabels = [];
      const checkedIds = [];

      $checkedGroupType.forEach((el) => {
        checkedIds.push($(el).attr('id'));

        if ($(el).attr('id') === 'all') {
          return;
        }

        checkedNames.push($(el).attr('name'));
      });

      const $inputLabel = $typeBlock.find('input').first().next('label');

      if (
        (checkedIds.length === 3 && checkedIds.indexOf('all') < 0)
        || checkedIds.length === 0
        || ($(event.currentTarget).attr('id') === 'all' && $(event.currentTarget).prop('checked'))
      ) {
        const $all = $typeBlock.find('input#all');
        $typeBlock.find('input[type="checkbox"]').prop('checked', false);
        $typeBlock.find('input#all').prop('checked', true);
        $inputLabel.text($all.attr('name'));

        this.common.sendGoogleEvent(
          'Main Search',
          'Select Adventure',
          $all.attr('name'),
        );

        return;
      }

      if (checkedIds.length > 1 && checkedIds.indexOf('all') >= 0) {
        $typeBlock.find('input#all').prop('checked', false);
      }

      $typeBlock.find('input:checked').forEach((el) => {
        checkedNamesLabels.push($(el).attr('name'));
      });

      this.common.sendGoogleEvent(
        'Main Search',
        'Select Adventure',
        checkedNamesLabels.join(', '),
      );

      $inputLabel.text(checkedNames.join(', '));
    });

    $typeBlock.find('input[type="checkbox"]').forEach((el) => {
      if (selectedAdventureType === 'standard' && $(el).attr('id') === TOUR_TYPE_ID_PERSONALIZED) {
        $(el).parent('label').addClass('hid');
        return;
      }

      if (selectedAdventureType === 'personalized' && $(el).prop('id') === TOUR_TYPE_ID_PERSONALIZED) {
        $(el).prop('checked', true).prop('disabled', true);
        $(el).trigger('change');
        return;
      }

      if (selectedAdventureType === 'personalized') {
        $(el).parent('label').addClass('hid');
      }
    });
  };

  this.toggleTypes = (action = 'auto') => {
    if (!$typeBlock || !$typeBlock.length) {
      return;
    }

    const $typesPopup = $typeBlock.find('.am-type-selector__wrapper');

    if (action === 'open' || this.isMobileFlow()) {
      $typesPopup.removeClass('hid');
      return;
    }

    if (action === 'close') {
      $typesPopup.addClass('hid');
      return;
    }

    $typesPopup.toggleClass('hid');
  };

  this.redirectToResultsPage = () => {
    const currentSearchTerm = $searchInput.val();
    const month = this.monthSelector ? this.monthSelector.getValue() : '';

    const query = `${currentSearchTerm} ${month}`;

    this.common.sendGoogleEvent(
      'Main Search',
      'Search',
      `No results - ${currentSearchTerm}`,
    );

    window.location.href = `/search?q=${query}`;
  };

  this.hideDefaultSuggestions = () => {
    if ($defaultSuggestions) {
      $defaultSuggestions.hide();
      $defaultSuggestions.find('.active').removeClass('active');
      selectedIndex = -1;
    }
  };

  this.onKeyDown = (event) => {
    if (!$defaultSuggestions || $defaultSuggestions.css('display') === 'none') {
      selectedIndex = -1;

      return;
    }

    event.preventDefault();
    event.stopPropagation();

    switch (event.keyCode) {
      case 38: // Up
        this.previousItem();
        break;
      case 40: // Down
        this.nextItem();
        break;
      case 13: // Enter
        this.onClickEnter();
        break;
      case 27: // Esc
        this.onClickEsc();
        break;
      default:
        break;
    }
  };

  this.onClickEsc = () => {
    $defaultSuggestions.hide();
    selectedIndex = -1;
  };

  this.onClickEnter = () => {
    $defaultSuggestions.find('.autocomplete-item.active').click();
  };

  this.nextItem = () => {
    selectedIndex += 1;

    if (selectedIndex >= defaultSuggestionsCount) {
      selectedIndex = 0;
    }

    this.renderActiveItem();
  };

  this.previousItem = () => {
    selectedIndex -= 1;

    if (selectedIndex < 0) {
      selectedIndex = defaultSuggestionsCount - 1;
    }

    this.renderActiveItem();
  };

  this.renderActiveItem = () => {
    $defaultSuggestions.find('.active').removeClass('active');
    $defaultSuggestions.find('.autocomplete-item').eq(selectedIndex).addClass('active');
  };

  this.groupTypeCheckbox = () => {
    const CHECKBOX_CLASS = '.js-ao-clp-hero-with-search__group-type-checkbox-input';
    const checkedNames = [];
    const checkedIds = {};
    const $checkedGroupType = $typeBlock && $typeBlock.length
      ? $typeBlock.find('input:checked')
      : $(`${CHECKBOX_CLASS}:checked`);

    if (!$checkedGroupType.length) {
      return;
    }

    $checkedGroupType.forEach((el) => {
      checkedNames.push($(el).attr('name'));

      const group = $(el).data('group');
      checkedIds[group] = checkedIds[group] || [];

      if ($(el).attr('id') === 'all') {
        return;
      }

      checkedIds[group].push($(el).attr('id'));
    });

    groupTypes = checkedIds;

    this.common.sendGoogleEvent(
      'Main Search',
      checkedNames.join(','),
    );
  };
}
